import { render, staticRenderFns } from "./Ergo_essentials.vue?vue&type=template&id=69840eca"
import script from "./Ergo_essentials.vue?vue&type=script&lang=js"
export * from "./Ergo_essentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports